"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
var clsx_1 = __importDefault(require("clsx"));
exports.LayoutMenuIcon = function (props) {
    var className = props.className, showBadge = props.showBadge;
    var iconProps = __assign(__assign({}, props), { className: '' });
    var useClassName = clsx_1.default('layout-menu-icon', className);
    return (react_1.default.createElement("div", { className: useClassName },
        react_1.default.createElement(react_2.Icon, __assign({}, iconProps)),
        showBadge && (react_1.default.createElement("div", { className: "layout-menu-badge-container" },
            react_1.default.createElement(react_2.Icon, { iconName: "LocationDot", className: "badge" })))));
};
//# sourceMappingURL=LayoutMenuIcon.js.map